import { useSelector } from 'react-redux';
// @ts-expect-error migrate dependency
import ConnectReferenceResolvers from 'reference-resolvers/ConnectReferenceResolvers';
// @ts-expect-error migrate dependency
import FilterOperatorDisplay from 'customer-data-filters/components/operator/FilterOperatorDisplay';
import { getSharedFilterOperatorProps } from 'platform-dashboard-ui/filter/utils/filterEditorUtils';
// @ts-expect-error migrate dependency
import { selectAllGates } from 'dashboard-lib/public/userInfo';
import { getIsUngated } from '../../../../lib/dashboardFilters/getDashboardFilterOperators';
import { jsx as _jsx } from "react/jsx-runtime";
const FilterListItem = ({
  currencyCode,
  dataSource,
  operator,
  resolvers,
  userId
}) => {
  const gates = useSelector(selectAllGates);
  return /*#__PURE__*/_jsx(FilterOperatorDisplay, Object.assign({
    operator: operator,
    isReadOnly: true,
    getIsUngated: getIsUngated(gates)
  }, getSharedFilterOperatorProps({
    currencyCode,
    dataSource,
    property: operator.get('field'),
    resolvers,
    userId,
    gates
  })));
};
export default ConnectReferenceResolvers(resolvers => ({
  resolvers
}))(FilterListItem);